export const REQUIREMENT_TYPES = [
  "Repair & Service",
  "AMC",
  "Laptop",
  "Desktop",
  "Monitor",
  "CCTV",
  "Laptop Battery",
  "Laptop Screen",
  "Laptop Stand",
  "Laptop Adapter",
  "Laptop Keyboard",
  "Website Development",
  "Software Development",
  "Computer Accessories",
  "Printer",
  "Scanner",
  "Networking Equipment",
  "Software",
  "Other",
];

export const REQUIREMENT_PRIORITIES = [
  "Low",
  "Medium",
  "High",
];

export const REQUIREMENT_STATUSES = [
  "Active",
  "In Progress",
  "Completed",
  "Closed",
];

export const REQUIREMENT_TABS = [
  {
    key: "",
    label: "All Requirements",
    summaryKey: "all",
  },
  {
    key: "Active",
    label: "Active",
    summaryKey: "active",
  },
  {
    key: "In Progress",
    label: "In Progress",
    summaryKey: "inProgress",
  },
  {
    key: "Completed",
    label: "Completed",
    summaryKey: "completed",
  },
  {
    key: "Closed",
    label: "Closed",
    summaryKey: "closed",
  },
];

export const EMPTY_REQUIREMENT_FILTERS = {
  search: "",
  requirementType: "",
  priority: "",
  dateFrom: "",
  dateTo: "",
};

export const EMPTY_REQUIREMENT_SUMMARY = {
  all: 0,
  active: 0,
  inProgress: 0,
  completed: 0,
  closed: 0,
};

export const EMPTY_REQUIREMENT_PAGINATION = {
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
};

export const INITIAL_REQUIREMENT_FORM = {
  customer: "",
  requirementType: "",
  description: "",
  priority: "Medium",
  status: "Active",
};

export const getRequirementStatusClass = (
  status
) => {
  const normalized = String(
    status || ""
  )
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");

  return `requirement-status requirement-status-${normalized}`;
};

export const getRequirementPriorityClass = (
  priority
) => {
  const normalized = String(
    priority || ""
  )
    .trim()
    .toLowerCase();

  return `requirement-priority requirement-priority-${normalized}`;
};

export const formatRequirementDate = (
  value,
  withTime = true
) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  if (!withTime) {
    return new Intl.DateTimeFormat(
      "en-IN",
      {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }
    ).format(date);
  }

  return new Intl.DateTimeFormat(
    "en-IN",
    {
      dateStyle: "medium",
      timeStyle: "short",
    }
  ).format(date);
};

export const getCustomerName = (
  customer
) => {
  return (
    customer?.customerName ||
    customer?.name ||
    "Unknown Customer"
  );
};

export const getCustomerMobile = (
  customer
) => {
  return (
    customer?.mobile ||
    customer?.phone ||
    "-"
  );
};

export const getRaisedByName = (
  requirement
) => {
  if (
    String(
      requirement?.raisedBy || ""
    ).toLowerCase() !== "staff"
  ) {
    return "Customer";
  }

  return (
    requirement?.raisedById?.name ||
    requirement?.raisedById?.firstName ||
    requirement?.raisedByUser?.name ||
    requirement?.raisedByUser?.firstName ||
    "Staff"
  );
};

export const getAttachmentFileName = (
  attachment
) => {
  if (!attachment) {
    return "Attachment";
  }

  const normalized = String(
    attachment
  ).replace(/\\/g, "/");

  return (
    normalized.split("/").pop() ||
    "Attachment"
  );
};

export const isImageAttachment = (
  attachment
) => {
  const fileName =
    getAttachmentFileName(
      attachment
    ).toLowerCase();

  return /\.(jpg|jpeg|png|webp|gif)$/i.test(
    fileName
  );
};

export const isPdfAttachment = (
  attachment
) => {
  const fileName =
    getAttachmentFileName(
      attachment
    ).toLowerCase();

  return /\.pdf$/i.test(fileName);
};